<div class="cap-alert-template-picker">
  <div class="cap-alert-template-picker__header">
    @if (mode() === 'change') {
      <button
        mat-icon-button
        type="button"
        id="capAlertPickerBackButton"
        class="cap-alert-template-picker__back"
        aria-label="Back"
        [focus-outline]="2"
        (click)="back.emit()"
      >
        <mat-icon svgIcon="arrow-left" aria-hidden="true" />
      </button>
    }
    <div class="cap-alert-template-picker__intro">
      <h2 #heading class="cap-alert-template-picker__title" tabindex="-1">
        Choose how alerts look
      </h2>
      <p class="cap-alert-template-picker__line">
        Your CAP provider supplies the alert text. The template sets the layout
        and styling. You can change it or customize it later.
      </p>
    </div>
  </div>

  <ul class="cap-alert-template-picker__list">
    @for (template of templates(); track template.productCode) {
      <li>
        <button
          type="button"
          class="cap-alert-template-picker__card"
          [class.cap-alert-template-picker__card--current]="isCurrent(template)"
          [attr.aria-current]="isCurrent(template) ? 'true' : null"
          [id]="'capAlertTemplate-' + template.productCode"
          [focus-outline]="2"
          (click)="chooseTemplate(template)"
        >
          <span class="cap-alert-template-picker__thumbnail">
            @if (imageUrl(template); as url) {
              <img [src]="url" alt="" loading="lazy" />
            }
          </span>
          <span class="cap-alert-template-picker__name">
            {{ template.name }}
            @if (isCurrent(template)) {
              <mat-icon
                class="cap-alert-template-picker__check"
                svgIcon="check"
                aria-hidden="true"
              />
              <span class="tw-sr-only"> (current)</span>
            }
          </span>
          @if (description(template); as text) {
            <span class="cap-alert-template-picker__description">{{
              text
            }}</span>
          }
        </button>
      </li>
    }

    @if (showCustomPresentation()) {
      <li>
        <button
          type="button"
          id="capAlertTemplate-custom-presentation"
          class="cap-alert-template-picker__card"
          [class.cap-alert-template-picker__card--current]="
            isCustomPresentationCurrent()
          "
          [attr.aria-current]="isCustomPresentationCurrent() ? 'true' : null"
          [disabled]="!canChoosePresentation()"
          [focus-outline]="2"
          (click)="choosePresentation()"
        >
          <span
            class="cap-alert-template-picker__thumbnail cap-alert-template-picker__thumbnail--icon"
          >
            <span class="cap-alert-template-picker__icon-tile">
              <mat-icon svgIcon="presentations" aria-hidden="true" />
            </span>
          </span>
          <span class="cap-alert-template-picker__name">
            {{ customPresentation.title }}
            @if (isCustomPresentationCurrent()) {
              <mat-icon
                class="cap-alert-template-picker__check"
                svgIcon="check"
                aria-hidden="true"
              />
              <span class="tw-sr-only"> (current)</span>
            }
          </span>
          <span class="cap-alert-template-picker__description">{{
            customPresentation.description
          }}</span>
        </button>
      </li>
    }
  </ul>
</div>
